import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
class ReferenceNumberField extends Component {
    constructor(props) {
        super(props);
        this.handleNameChangeDropdown = (e) => {
            const refName = e.target.value;
            if (refName === 'custom') {
                this.setState({ isCustom: true }, () => {
                    this.props.onChange('name', '');
                });
            }
            else {
                this.props.onChange('name', refName);
            }
        };
        this.handleNameChangeText = (e) => {
            this.props.onChange('name', e.target.value);
        };
        this.handleValueChange = (e) => this.props.onChange('value', e.target.value);
        this.handleRemove = (e) => {
            e.preventDefault();
            this.props.onRemove();
        };
        this.state = {
            isCustom: false,
        };
    }
    render() {
        const { referenceNumber: { name, value }, refNumbersList, t, } = this.props;
        const placeholder = refNumbersList.length
            ? 'SELECT_A_TYPE'
            : 'ENTER_SHIPPER';
        if (featureEnabled(CONFIGURED_FEATURES.SSR) && !this.state.isCustom) {
            return (React.createElement("div", { className: this.props.displayClass || 'reference-number-fields' },
                React.createElement("div", { className: this.props.interiorClass ||
                        'reference-number-field flex flex-wrap content-center items-center' },
                    React.createElement("div", { className: "sm:w-1/3 w-2/5" },
                        React.createElement("fieldset", { className: "md:mr-2" },
                            React.createElement("select", { className: "block w-full mb-4 form-select", value: this.props.referenceNumber.name, placeholder: t('SELECT_REFERENCE_NUM_TYPE'), onChange: this.handleNameChangeDropdown },
                                React.createElement("option", { key: "default-0", value: "" }, t(placeholder)),
                                refNumbersList.map((ref) => {
                                    var _a;
                                    return (React.createElement("option", { name: ref.reference_number, value: ref.reference_number }, t((_a = ref === null || ref === void 0 ? void 0 : ref.reference_number) === null || _a === void 0 ? void 0 : _a.toUpperCase())));
                                }),
                                React.createElement("option", { value: "custom" }, t('CUSTOM'))))),
                    React.createElement("div", { className: "sm:w-2/3 w-1/2 flex items-center" },
                        React.createElement("fieldset", { className: "mr-2 md:w-2/3" },
                            React.createElement("input", { type: "text", className: "block w-full mb-4 form-field", placeholder: t('REFERENCE_NUMBER_VALUE'), value: value, onChange: this.handleValueChange })),
                        React.createElement("a", { href: "#", className: "mb-4", onClick: this.handleRemove },
                            React.createElement("i", { className: "fa fa-remove secondary-action" }))))));
        }
        return (React.createElement("div", { className: this.props.displayClass || 'reference-number-fields' },
            React.createElement("div", { className: this.props.interiorClass ||
                    'reference-number-field flex flex-wrap content-center items-center' },
                React.createElement("div", { className: "sm:w-1/3 w-2/5" },
                    React.createElement("fieldset", { className: "md:mr-2" },
                        React.createElement("input", { type: "text", className: "w-full mb-4 block form-field", placeholder: t('REFERENCE_NUMBER_NAME'), value: name, onChange: this.handleNameChangeText }))),
                React.createElement("div", { className: "sm:w-2/3 w-1/2 flex items-center" },
                    React.createElement("fieldset", { className: "mr-2 md:w-2/3" },
                        React.createElement("input", { type: "text", className: "block w-full mb-4 form-field", placeholder: t('REFERENCE_NUMBER_VALUE'), value: value, onChange: this.handleValueChange })),
                    React.createElement("a", { href: "#", className: "mb-4", onClick: this.handleRemove },
                        React.createElement("i", { className: "fa fa-remove secondary-action" }))))));
    }
}
ReferenceNumberField.propTypes = {
    referenceNumber: PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
    }).isRequired,
    displayClass: PropTypes.string,
    interiorClass: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};
export default withTranslation()(ReferenceNumberField);
